import React, { useRef, useState } from "react";
import NewListingItem from "./NewListingItem";
import listing1 from "../../../images/Listing/Listing1.jpg";
import listing2 from "../../../images/Listing/Listing2.jpg";
import listing3 from "../../../images/Listing/Listing3.jpg";
import listing4 from "../../../images/Listing/Listing4.jpg";
import Slider from "react-slick/lib/slider";

const NewListing = () => {
  const [activeColor, setActiveColor] = useState("Newly Listed");
  const sliderRef = useRef(null);
  const settings = {
    className: "center",
    infinite: true,
    arrows: false,
    dots: false,
    centerPadding: "60px",
    slidesToShow: 3,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="common_bg_weShare mt-5">
      <div className="container pb-2 pt-1">
        {/* <div className="main_title">
          <Fade left>
            <h1 className="sectionHeader111 pb-3 pt-1">
              <span className="text-yellow">New</span>
              <span className="text-blue">
                {" "}
                Listing{" "}
                <span className="headerPsudo22">
                  <img src={headerBg} alt="" />
                </span>
              </span>
            </h1>
          </Fade>
        </div> */}
        <div className="row w-100">
          {/* <h1 className="sectionHeader3">
              <span className="text-yellow3">We </span>
              <span className="text-blue3" style={{ position: "relative" }}>
                Share
                <span className="headerPsudo3">
                  <img src={headerBg} alt="" />
                </span>
                <span className="headerPsudoText3">
                  <span className="p">a sustainable lifestyle</span>
                </span>
              </span>
            </h1> */}
          <div className=" ms-2 pt-3 new_list_main">
            <button
              onClick={() => setActiveColor("Newly Listed")}
              className={`  new_list_btn ${
                activeColor === "Newly Listed" ? "activeList" : ""
              }`}
            >
              Newly Listed
            </button>
            <button
              onClick={() => setActiveColor("Popular")}
              className={`mx-4 new_list_btn ${
                activeColor === "Popular" ? "activeList" : ""
              }`}
            >
              Popular
            </button>
            <button
              onClick={() => setActiveColor("Featured")}
              className={`new_list_btn ${
                activeColor === "Featured" ? "activeList" : ""
              }`}
            >
              Featured
            </button>
          </div>
          <div>
            <Slider {...settings} ref={sliderRef}>
              {/* add */}

              <NewListingItem
                img={listing1}
                name={"Property"}
                title={"Magical Deserts"}
                city={"United States"}
                price={"$600 per week"}
              />
              <NewListingItem
                img={listing2}
                name={"Vehicles"}
                title={"Honda C"}
                city={"Toronto"}
                price={"$100 per week"}
              />
              <NewListingItem
                img={listing3}
                name={"Film Equipment"}
                title={"Pro Camera"}
                city={"Tel Aviv"}
                price={"$100 per day"}
              />
              <NewListingItem
                img={listing4}
                name={"Boat"}
                title={"Magical Boats"}
                city={"Dubai"}
                price={"$30 per hour"}
              />
              <NewListingItem
                img={listing4}
                name={"Boat"}
                title={"Magical Boats"}
                city={"Dubai"}
                price={"$30 per hour"}
              />
            </Slider>
            <div className="d-flex arrow_main justify-content-center align-items-center">
              <div
                className="left"
                onClick={() => sliderRef.current.slickPrev()}
              >
                <i className="fas fa-arrow-left"></i>
              </div>
              <div
                className="right"
                onClick={() => sliderRef.current.slickNext()}
              >
                <i className="fas fa-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewListing;
